import { DeleteData, GetOptData, UpdateData, IsNotNull, GetAllData, CreateData, GetData } from '../commons/helper';

const jwt = require("jsonwebtoken");
const { crypter_s} = require("../../controllers/encrypt/encrypt");

const rolesAll = async (b) => {
  let result = { data: [], tp: 1 };
  let url = process.env.REACT_APP_API_URL + "roles-all";
  let tmpSC = ''
  tmpSC = b.p4.column === "Role" ? "rl_name" : tmpSC;
  tmpSC = b.p4.column === "Code" ? "rl_code" : tmpSC;
  tmpSC = b.p4.column === "Status" ? "rl_status" : tmpSC;
  b.p4.column = tmpSC
  await GetAllData(b, url).then(x => { result = x })
  return result;
}

const createRole = async (b) => {
  let result = { code: 'C-00', status: false, message: '' };
  let url = process.env.REACT_APP_API_URL + "role-create";
  await CreateData(b, url).then(x => { result = x })
  return result;
}

const deleteRole = async (b) => {
  let result = { code: 'D-00', status: false, message: '' };
  let url = process.env.REACT_APP_API_URL + "role-delete";
  await DeleteData(b, url).then(x => { result = x })
  return result;
}

const updateRole = async (b) => {
  let result = { code: 'U-00', status: false, message: '' };
  let url = process.env.REACT_APP_API_URL + "role-update";
  await UpdateData(b, url).then(x => { result = x })
  return result;
}

const getRolesForOptions = async () => {
  let result = null
  let url = process.env.REACT_APP_API_URL + "roles-for-opt"
  await GetOptData(url).then(x => { result = IsNotNull(x) ? x : null })
  return result;
}

const getRoles = async () => {
  let role = []
  if (localStorage.getItem("authUser") != null) {
    if (JSON.parse(localStorage.getItem("authUser")).token != undefined &&
      JSON.parse(localStorage.getItem("authUser")).token != null && JSON.parse(localStorage.getItem("authUser")).token != '') {
      const decrypted = await crypter_s().decrypt(JSON.parse(localStorage.getItem("authUser")).token);
      const rs_d = jwt.decode(decrypted);
      role = rs_d.role.split(',');
    }
  }
  return role
}

const getMealsHandler = async ()=>{
  let role = []
  if (localStorage.getItem("authUser") != null) {
    if (JSON.parse(localStorage.getItem("authUser")).token != undefined &&
      JSON.parse(localStorage.getItem("authUser")).token != null && JSON.parse(localStorage.getItem("authUser")).token != '') {
      const decrypted = await crypter_s().decrypt(JSON.parse(localStorage.getItem("authUser")).token);
      const rs_d = jwt.decode(decrypted);
      role = rs_d.meals_handler;
    }
  }
  return role
}

export {
  rolesAll,
  createRole,
  deleteRole,
  updateRole,
  getRolesForOptions,
  getRoles,
  getMealsHandler
}